import { useEffect, useState, useRef } from "react";
import "./completeSList.css";
import Table from "react-bootstrap/Table";
import CompleteSTableProps from "./Complete_table_props/CompleteSTableProps";
import LeaderBoard from "../leaderBoar/LeaderBoard";
import axios from "../../../../axios";
import { useLocation } from "react-router-dom";
import moment from "moment";
import {
  Box,
  Button,
  Paper,
  Stack,
  Typography,
  Chip,
  TextField,
  InputAdornment,
  CircularProgress,
  Tooltip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
} from "@mui/material";
import ArrowBackIosNewRoundedIcon from "@mui/icons-material/ArrowBackIosNewRounded";
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import SearchOffRoundedIcon from "@mui/icons-material/SearchOffRounded";
import EmojiEventsRoundedIcon from "@mui/icons-material/EmojiEventsRounded";
import AutoAwesomeRoundedIcon from "@mui/icons-material/AutoAwesomeRounded";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import CloudOffRoundedIcon from "@mui/icons-material/CloudOffRounded";
import EditNoteRoundedIcon from "@mui/icons-material/EditNoteRounded";

import ExportTablePDf from "../../../../Components/exportTablePDf";

const CompleteStudentList = () => {
  const [click, setClick] = useState(false);
  const { state } = useLocation();
  const [studentList, setStudentList] = useState([]);
  const [assessment, setAssessment] = useState();
  // ⭐ Initial value array (pehle {} object tha → crash)
  const [leaderBoardData, setLeaderBoredData] = useState([]);
  const [inGettingStudentProcess, setInGettingStudentProcess] = useState(false);
  const [leaderBoardPData, setLeaderBoardPData] = useState(null);

  // ⭐ Offline-entry dialog
  const [offlineDialogOpen, setOfflineDialogOpen] = useState(false);
  const [offlineStudent, setOfflineStudent] = useState(null);

  const [filter, setFilter] = useState({ name: "" });
  const { name } = filter;

  const [debouncedName, setDebouncedName] = useState("");
  const debounceRef = useRef(null);

  useEffect(() => {
    clearTimeout(debounceRef.current);
    debounceRef.current = setTimeout(() => {
      setDebouncedName(name);
    }, 300);
    return () => clearTimeout(debounceRef.current);
  }, [name]);

  // Load student list
  useEffect(() => {
    const getStudentList = async () => {
      setInGettingStudentProcess(true);
      try {
        const studentRes = await axios.get(
          `/api/v1/assessment/studentAssessment/getByAssessmentId/${
            state.assessmentId
          }?${debouncedName ? `name=${debouncedName}` : ""}`,
        );

        if (studentRes?.data?.data?.length > 0) {
          setAssessment(studentRes.data.data[0]?.assessment_id);
        }
        setStudentList(studentRes.data.data);
      } catch (error) {
        console.log(error);
      } finally {
        setInGettingStudentProcess(false);
      }
    };
    getStudentList();
  }, [debouncedName]);

  // ⭐ Leaderboard fetch — event-safe + empty guard
  const getLeaderBoard = async (e) => {
    if (e?.preventDefault) e.preventDefault();
    if (e?.stopPropagation) e.stopPropagation();

    try {
      setInGettingStudentProcess(true);
      const res = await axios.get(
        `/api/v1/assessment/${state.assessmentId}/studentLeaderBoard/get`,
      );

      // ⭐ Empty data guard — warna `res.data.data[0].student.id` crash karta
      if (!res?.data?.data?.length) {
        console.warn("Leaderboard data empty");
        return;
      }

      const studentId = res.data.data[0].student.id;
      const stats = await axios.get(
        `/api/v1/assessment/${state.assessmentId}/studentAssessmentStats/student/${studentId}/get`,
      );

      setLeaderBoardPData(stats.data.data);

      const sorted = [...res.data.data].sort((a, b) => {
        const scoreA = a?.assessment?.isAdaptive
          ? a?.ability || 0
          : a?.obtained_marks || 0;
        const scoreB = b?.assessment?.isAdaptive
          ? b?.ability || 0
          : b?.obtained_marks || 0;
        return scoreB - scoreA;
      });

      setLeaderBoredData(sorted);
      setClick(true);
    } catch (error) {
      console.log("leaderboard error:", error?.response?.data || error);
    } finally {
      setInGettingStudentProcess(false);
    }
  };

  const dateHelper = (a) => {
    const dateObj = new Date(a);
    return `${dateObj.getUTCDate()}/${
      dateObj.getUTCMonth() + 1
    }/${dateObj.getUTCFullYear()}`;
  };

  const isAutoEval = !!assessment?.autoEvalEnabled;
  const totalStudents = studentList.length;

  // ⭐ Offline entry helpers
  const offlineStudents = studentList.filter(
    (s) => s?.is_offline_entry === true,
  );
  const anyOfflineEntry = offlineStudents.length > 0;

  const openOfflineDialog = (student) => {
    setOfflineStudent(student);
    setOfflineDialogOpen(true);
  };

  const closeOfflineDialog = () => {
    setOfflineDialogOpen(false);
    setOfflineStudent(null);
  };

  // ───────── Loading initial ─────────
  if (inGettingStudentProcess && !assessment) {
    return (
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          minHeight: "60vh",
        }}
      >
        <Stack alignItems="center" spacing={1.5}>
          <CircularProgress size={28} sx={{ color: "#2563eb" }} />
          <Typography fontSize={13} color="text.secondary">
            Loading…
          </Typography>
        </Stack>
      </Box>
    );
  }

  // ───────── Not found ─────────
  if (!assessment) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "60vh",
          p: 2,
        }}
      >
        <Paper
          elevation={0}
          sx={{
            p: 4,
            textAlign: "center",
            borderRadius: 3,
            border: "1px solid #e5e7eb",
            maxWidth: 420,
          }}
        >
          <ErrorOutlineIcon sx={{ fontSize: 56, color: "#ef4444", mb: 1.5 }} />
          <Typography fontWeight={700} fontSize={16} color="#111827">
            Oops, something went wrong
          </Typography>
          <Typography fontSize={13} color="text.secondary" mt={0.5}>
            Student Not Found!
          </Typography>
          <Stack direction="row" justifyContent="center" mt={3}>
            <Button
              variant="outlined"
              onClick={() => window.history.back()}
              sx={{
                textTransform: "none",
                fontWeight: 600,
                borderRadius: 2,
                px: 3,
                borderColor: "#e5e7eb",
                color: "#374151",
                "&:hover": { borderColor: "#d1d5db", bgcolor: "#f9fafb" },
              }}
            >
              Go Back
            </Button>
          </Stack>
        </Paper>
      </Box>
    );
  }

  // ───────── Main ─────────
  return (
    <Box
      className="container-fluid px-4 py-3"
      sx={{ bgcolor: "#f7f8fa", minHeight: "100vh" }}
    >
      {/* ───────── Compact top bar ───────── */}
      <Paper
        elevation={0}
        sx={{
          px: 2.5,
          py: 1.5,
          mb: 2,
          borderRadius: 2.5,
          border: "1px solid #e5e7eb",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: 2,
          flexWrap: "wrap",
        }}
      >
        {/* Left — back + title + meta */}
        <Stack
          direction="row"
          spacing={1.5}
          alignItems="center"
          sx={{ minWidth: 0 }}
        >
          <Box
            onClick={() => window.history.back()}
            sx={{
              width: 34,
              height: 34,
              borderRadius: "50%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              bgcolor: "#f3f4f6",
              cursor: "pointer",
              flexShrink: 0,
              transition: "all .15s",
              "&:hover": { bgcolor: "#e5e7eb" },
            }}
          >
            <ArrowBackIosNewRoundedIcon
              sx={{ fontSize: 15, color: "#374151" }}
            />
          </Box>

          <Box sx={{ minWidth: 0 }}>
            <Stack
              direction="row"
              spacing={1}
              alignItems="center"
              flexWrap="wrap"
              useFlexGap
            >
              <Typography fontWeight={700} fontSize={15} color="#111827" noWrap>
                {assessment?.name || "Loading…"}
              </Typography>

              <Chip
                label="COMPLETED"
                size="small"
                sx={{
                  height: 20,
                  bgcolor: "#dcfce7",
                  color: "#15803d",
                  fontWeight: 700,
                  fontSize: 10,
                  letterSpacing: 0.5,
                }}
              />

              {isAutoEval && (
                <Tooltip
                  arrow
                  title="Marks were generated automatically by the system"
                >
                  <Chip
                    icon={
                      <AutoAwesomeRoundedIcon
                        sx={{ fontSize: "14px !important" }}
                      />
                    }
                    label="AUTO EVALUATED"
                    size="small"
                    sx={{
                      height: 20,
                      bgcolor: "#e0e7ff",
                      color: "#3730a3",
                      fontWeight: 700,
                      fontSize: 10,
                      letterSpacing: 0.5,
                      "& .MuiChip-icon": { color: "#3730a3" },
                    }}
                  />
                </Tooltip>
              )}

              {anyOfflineEntry && (
                <Tooltip
                  arrow
                  title="Some students' marks were entered manually from the score card"
                >
                  <Chip
                    icon={
                      <CloudOffRoundedIcon
                        sx={{ fontSize: "14px !important" }}
                      />
                    }
                    label={`OFFLINE (${offlineStudents.length})`}
                    size="small"
                    onClick={() => openOfflineDialog(offlineStudents[0])}
                    sx={{
                      height: 20,
                      bgcolor: "#ecfdf5",
                      color: "#047857",
                      fontWeight: 700,
                      fontSize: 10,
                      letterSpacing: 0.5,
                      cursor: "pointer",
                      "& .MuiChip-icon": { color: "#047857" },
                    }}
                  />
                </Tooltip>
              )}
            </Stack>

            <Typography
              fontSize={11}
              color="text.secondary"
              noWrap
              sx={{ mt: 0.2 }}
            >
              {assessment?.subject?.name || "—"} · Evaluated{" "}
              {dateHelper(assessment?.updated_at)} ·{" "}
              {moment(assessment?.updated_at).format("h:mm a")}
            </Typography>
          </Box>
        </Stack>

        {/* Right — export + leaderboard */}
        <Stack direction="row" spacing={1.25} alignItems="center">
          <ExportTablePDf
            studentinfo={studentList}
            basicinfo={assessment}
            isAssessment={true}
          />

          <Button
            type="button"
            variant="contained"
            size="small"
            startIcon={<EmojiEventsRoundedIcon sx={{ fontSize: 16 }} />}
            onClick={(e) => getLeaderBoard(e)}
            sx={{
              background: "linear-gradient(135deg,#f59e0b,#d97706)",
              textTransform: "none",
              fontWeight: 600,
              fontSize: 13,
              borderRadius: 2,
              px: 2,
              py: 0.75,
              boxShadow: "0 3px 10px rgba(245,158,11,.25)",
              "&:hover": {
                background: "linear-gradient(135deg,#d97706,#b45309)",
                boxShadow: "0 5px 14px rgba(245,158,11,.35)",
              },
            }}
          >
            Leaderboard
          </Button>
        </Stack>
      </Paper>

      {/* ───────── Offline-entry info banner ───────── */}
      {anyOfflineEntry && (
        <Paper
          elevation={0}
          sx={{
            px: 2,
            py: 1.25,
            mb: 1.5,
            borderRadius: 2,
            border: "1px solid #a7f3d0",
            bgcolor: "#ecfdf5",
            display: "flex",
            alignItems: "center",
            gap: 1.25,
          }}
        >
          <CloudOffRoundedIcon sx={{ fontSize: 18, color: "#047857" }} />
          <Typography fontSize={12} color="#065f46">
            <strong>{offlineStudents.length}</strong> student
            {offlineStudents.length > 1 ? "s" : ""} marked with{" "}
            <Box component="span" sx={{ fontWeight: 700 }}>
              Offline
            </Box>{" "}
            — their marks were entered manually from the score card, not via
            online submission.
          </Typography>
        </Paper>
      )}

      {/* ───────── Table card ───────── */}
      <Paper
        elevation={0}
        sx={{
          borderRadius: 2.5,
          border: "1px solid #e5e7eb",
          overflow: "hidden",
        }}
      >
        {/* Card header — search row */}
        <Box
          sx={{
            px: 2.5,
            py: 1.5,
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: 2,
            flexWrap: "wrap",
          }}
        >
          <Stack direction="row" spacing={1} alignItems="center">
            <Typography fontWeight={700} fontSize={14} color="#111827">
              Students
            </Typography>
            <Chip
              label={totalStudents}
              size="small"
              sx={{
                height: 20,
                minWidth: 24,
                bgcolor: "#eef2ff",
                color: "#1d4ed8",
                fontWeight: 700,
                fontSize: 11,
              }}
            />

            {isAutoEval && (
              <Chip
                icon={
                  <AutoAwesomeRoundedIcon
                    sx={{ fontSize: "13px !important" }}
                  />
                }
                label="Auto-scored"
                size="small"
                sx={{
                  height: 20,
                  bgcolor: "#ecfdf5",
                  color: "#047857",
                  fontWeight: 600,
                  fontSize: 10,
                  "& .MuiChip-icon": { color: "#047857" },
                }}
              />
            )}

            {anyOfflineEntry && (
              <Chip
                icon={
                  <CloudOffRoundedIcon sx={{ fontSize: "13px !important" }} />
                }
                label={`${offlineStudents.length} offline`}
                size="small"
                sx={{
                  height: 20,
                  bgcolor: "#ecfdf5",
                  color: "#047857",
                  fontWeight: 600,
                  fontSize: 10,
                  "& .MuiChip-icon": { color: "#047857" },
                }}
              />
            )}
          </Stack>

          <TextField
            size="small"
            placeholder="Search by student name…"
            value={name}
            onChange={(e) => setFilter({ ...filter, name: e.target.value })}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchRoundedIcon
                    fontSize="small"
                    sx={{ color: "#9ca3af", fontSize: 18 }}
                  />
                </InputAdornment>
              ),
            }}
            sx={{
              width: { xs: "100%", sm: 300 },
              "& .MuiOutlinedInput-root": {
                borderRadius: 2,
                bgcolor: "#f9fafb",
                fontSize: 13,
                "& fieldset": { borderColor: "#e5e7eb" },
                "&:hover fieldset": { borderColor: "#c7d2fe" },
                "&.Mui-focused fieldset": { borderColor: "#2563eb" },
              },
            }}
          />
        </Box>

        {/* Divider */}
        <Box sx={{ borderTop: "1px solid #f3f4f6" }} />

        {/* Table */}
        <Box sx={{ maxHeight: 400, overflowY: "auto" }}>
          <Table
            borderless
            hover
            className="mb-0 align-middle h-full"
            style={{
              textAlign: "center",
              borderCollapse: "separate",
              borderSpacing: 0,
              marginBottom: 0,
            }}
          >
            <thead>
              <tr>
                {[
                  "Name",
                  "Roll No.",
                  "Class",
                  "Division",
                  "Date submitted",
                  assessment?.isAdaptive ? "Score" : "Mark",
                  "Status",
                ].map((h) => (
                  <th
                    key={h}
                    style={{
                      position: "sticky",
                      top: 0,
                      zIndex: 3,
                      backgroundColor: "#f9fafb",
                      color: "#6b7280",
                      fontWeight: 600,
                      fontSize: 12,
                      letterSpacing: 0.3,
                      textTransform: "uppercase",
                      padding: "14px 12px",
                      borderBottom: "1px solid #e5e7eb",
                      whiteSpace: "nowrap",
                    }}
                  >
                    {h}
                  </th>
                ))}
              </tr>
            </thead>

            <tbody style={{ fontSize: 13, color: "#374151" }}>
              {inGettingStudentProcess ? (
                <tr>
                  <td colSpan="7" style={{ padding: "56px 0" }}>
                    <Stack alignItems="center" spacing={1.5}>
                      <CircularProgress size={26} sx={{ color: "#2563eb" }} />
                      <Typography fontSize={12} color="text.secondary">
                        Loading students…
                      </Typography>
                    </Stack>
                  </td>
                </tr>
              ) : studentList?.length > 0 ? (
                <CompleteSTableProps
                  studentList={studentList}
                  isAutoEval={isAutoEval}
                  onOfflineClick={openOfflineDialog}
                />
              ) : (
                <tr>
                  <td colSpan="7" style={{ padding: "56px 0" }}>
                    <Stack alignItems="center" spacing={0.75}>
                      <SearchOffRoundedIcon
                        sx={{ fontSize: 38, color: "#d1d5db" }}
                      />
                      <Typography
                        fontWeight={600}
                        fontSize={14}
                        color="#374151"
                      >
                        No student found
                      </Typography>
                      <Typography fontSize={12} color="text.secondary">
                        Try searching with a different name.
                      </Typography>
                    </Stack>
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </Box>
      </Paper>

      {/* ───────── Leaderboard ───────── */}
      {click && (
        <LeaderBoard
          assessmentId={state.assessmentId}
          leaderBoardPData={leaderBoardPData}
          subject={assessment?.subject?.name}
          leaderBoardData={leaderBoardData}
          setClick={setClick}
          isAdaptive={assessment?.isAdaptive}
        />
      )}

      {/* ───────── Offline entry dialog ───────── */}
      <Dialog
        open={offlineDialogOpen}
        onClose={closeOfflineDialog}
        maxWidth="xs"
        fullWidth
        PaperProps={{
          sx: { borderRadius: 2.5 },
        }}
      >
        <DialogTitle
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1,
            fontSize: 15,
            fontWeight: 700,
            color: "#047857",
            pb: 1,
          }}
        >
          <CloudOffRoundedIcon sx={{ fontSize: 20, color: "#047857" }} />
          Offline Entry
        </DialogTitle>

        <DialogContent sx={{ pt: 0 }}>
          <DialogContentText sx={{ fontSize: 13, color: "#4b5563", mb: 2 }}>
            The marks shown for this student were entered manually from this
            score card — not via an online submission.
          </DialogContentText>

          {offlineStudent && (
            <Paper
              elevation={0}
              sx={{
                p: 1.75,
                borderRadius: 2,
                bgcolor: "#f9fafb",
                border: "1px solid #e5e7eb",
              }}
            >
              <Stack spacing={0.75} fontSize={13}>
                <Typography fontSize={13}>
                  <Box
                    component="span"
                    sx={{ color: "#6b7280", fontWeight: 500 }}
                  >
                    Student:{" "}
                  </Box>
                  <Box
                    component="span"
                    sx={{ fontWeight: 700, color: "#111827" }}
                  >
                    {offlineStudent?.student_id?.name || "—"}
                  </Box>
                </Typography>

                <Typography fontSize={13}>
                  <Box
                    component="span"
                    sx={{ color: "#6b7280", fontWeight: 500 }}
                  >
                    Roll No.:{" "}
                  </Box>
                  <Box
                    component="span"
                    sx={{ fontWeight: 600, color: "#111827" }}
                  >
                    {offlineStudent?.student_id?.roll_number || "—"}
                  </Box>
                </Typography>

                <Typography fontSize={13}>
                  <Box
                    component="span"
                    sx={{ color: "#6b7280", fontWeight: 500 }}
                  >
                    Marks:{" "}
                  </Box>
                  <Box
                    component="span"
                    sx={{ fontWeight: 700, color: "#047857" }}
                  >
                    {offlineStudent?.obtained_marks ?? "—"}
                    {assessment?.total_marks
                      ? ` / ${assessment.total_marks}`
                      : ""}
                  </Box>
                </Typography>

                <Typography fontSize={13}>
                  <Box
                    component="span"
                    sx={{ color: "#6b7280", fontWeight: 500 }}
                  >
                    Status:{" "}
                  </Box>
                  <Box
                    component="span"
                    sx={{ fontWeight: 600, color: "#111827" }}
                  >
                    {offlineStudent?.status || "—"}
                  </Box>
                </Typography>

                <Typography fontSize={13}>
                  <Box
                    component="span"
                    sx={{ color: "#6b7280", fontWeight: 500 }}
                  >
                    Updated:{" "}
                  </Box>
                  <Box
                    component="span"
                    sx={{ fontWeight: 600, color: "#111827" }}
                  >
                    {offlineStudent?.updated_at
                      ? `${dateHelper(offlineStudent.updated_at)} · ${moment(
                          offlineStudent.updated_at,
                        ).format("h:mm a")}`
                      : "—"}
                  </Box>
                </Typography>
              </Stack>
            </Paper>
          )}

          <Stack
            direction="row"
            alignItems="center"
            spacing={1}
            sx={{
              mt: 2,
              p: 1.25,
              borderRadius: 2,
              bgcolor: "#ecfdf5",
              border: "1px dashed #a7f3d0",
            }}
          >
            <EditNoteRoundedIcon
              sx={{ fontSize: 18, color: "#047857", flexShrink: 0 }}
            />
            <Typography fontSize={11.5} color="#065f46">
              Editable from the class score card — admin/teacher can update
              offline marks anytime.
            </Typography>
          </Stack>
        </DialogContent>

        <DialogActions sx={{ px: 3, pb: 2 }}>
          <Button
            onClick={closeOfflineDialog}
            size="small"
            sx={{
              textTransform: "none",
              fontWeight: 600,
              fontSize: 13,
              borderRadius: 2,
              px: 2.5,
              color: "#047857",
              "&:hover": { bgcolor: "#ecfdf5" },
            }}
          >
            Got it
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default CompleteStudentList;
